'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createContextualByline;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentContext = require('@spp/component-context');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createContextualByline(Byline) {
    var ContextualByline = function ContextualByline(props) {
        return _react2.default.createElement(
            _componentContext.CurrentArticle,
            null,
            function (article) {
                return _react2.default.createElement(Byline, (0, _extends3.default)({}, props, { originators: article.authors }));
            }
        );
    };

    return ContextualByline;
}
//# sourceMappingURL=ContextualByline.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-byline/lib/cjs/ContextualByline.js
 ** module id = 579
 ** module chunks = 1
 **/